<template>
  <div>
    <b-form-checkbox-group
      :options="timeOfDayOption"
      name="timeOfDayOptions"
      v-model="selectedTimeOfDay"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeOfDayOption: [
        { value: "MORNING", text: "Morning" },
        { value: "AFTERNOON", text: "Afternoon" },
        { value: "EVENING", text: "Evening" },
      ],
      selectedTimeOfDay: null,
    };
  },
  created() {
    this.selectedTimeOfDay = ["MORNING", "AFTERNOON", "EVENING"];
  },
  watch: {
    selectedTimeOfDay: {
      immediate: true,
      handler(n, old) {
        this.$emit("updated", n);
      },
    },
  },
};
</script>

<style></style>
